import React from 'react'
import { Box, BoxProps, forwardRef } from '~/design_system'

/**
 * Factory for lucide-style stroke icons (viewBox 0 0 24 24, no fill, currentColor stroke).
 * VNDLY's `createIcon` only supports filled paths on a 1024 viewBox, so the assistant
 * uses this to match the lucide icons from its design source.
 */
export const createLucideIcon = (displayName: string, children: React.ReactNode) => {
  const Comp = forwardRef<BoxProps, 'div'>((props, ref) => (
    <Box
      ref={ref}
      as="svg"
      viewBox="0 0 24 24"
      w="24px"
      h="24px"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      display="inline-block"
      verticalAlign="middle"
      flexShrink={0}
      aria-hidden
      {...props}>
      {children}
    </Box>
  ))

  if (process.env.NODE_ENV !== 'production') {
    Comp.displayName = displayName
  }

  return Comp
}
